var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
// Coupling with query-hooks!
import { useCallback, useEffect, useMemo, useRef, useState, } from 'react';
import { createSdk } from '@lucidlink/sdk';
import { assertCanHandle, getRootLogger } from '@lucidlink/tscore';
import { LoadingBox, translate } from '@lucidlink/uicore';
import { DEPENDENCY_KEYS, useDependency } from '../DependencyInjection';
import { LucidSdkContext } from './LucidSdkContext';
export const LucidSdkProvider = ({ children }) => {
    _react_refresh_temp_2();
    const webserviceUrl = useDependency(DEPENDENCY_KEYS.WEB_SERVICE_ENDPOINT);
    const additionalInfo = useDependency(DEPENDENCY_KEYS.GetAdditionalInfo)();
    const [lucidSdk, setLucidSdk] = useState(null);
    const [sdkError, setSdkError] = useState(null);
    const isSdkInitializedRef = useRef(false);
    const isMountedRef = useRef(true);
    const initSdk = useCallback(async () => {
        if (isMountedRef.current) {
            setLucidSdk(null);
        }
        try {
            const sdk = await createSdk({
                baseUrl: webserviceUrl,
                logger: getRootLogger(),
                additionalInfo: additionalInfo,
            });
            // This needs to be here before initializing the AuthProvider
            await sdk.authenticationClient().restoreLogin();
            if (isMountedRef.current) {
                setLucidSdk(sdk);
            }
        }
        catch (error) {
            assertCanHandle(error, () => true);
            if (isMountedRef.current) {
                setSdkError(error);
            }
        }
    }, [additionalInfo, webserviceUrl]);
    useEffect(() => {
        isMountedRef.current = true;
        if (isSdkInitializedRef.current) {
            return;
        }
        isSdkInitializedRef.current = true;
        void initSdk();
        return () => {
            isMountedRef.current = false;
        };
    }, [webserviceUrl, additionalInfo, initSdk]);
    const value = useMemo(() => ({
        lucidSdk: lucidSdk, //We provide this value only after we have lucidSdk
    }), [lucidSdk]);
    if (sdkError) {
        throw sdkError;
    }
    if (!lucidSdk) {
        return (_jsx(LoadingBox, { alt: translate('Loading'), "data-testid": "loading-sdk", isCoverPage: true }));
    }
    return (_jsx(LucidSdkContext.Provider, { value: value, children: children }));
};
_react_refresh_temp_1 = LucidSdkProvider;
$RefreshReg$(_react_refresh_temp_1, "LucidSdkProvider");
_react_refresh_temp_2(LucidSdkProvider, "b9X9buVnyGErRnKVKKJ7HxJPpdk=", false, () => [useDependency, useDependency]);
